const ENDPOINTS = {
  plans: () => '/api/billings',
  checkout: (price: string, trial: boolean) =>
    `/api/billings/checkout?price=${price}&${trial && 'trial=true'}`,
  subscription: () => '/api/billings/subscription',
  manage: () => '/api/billings/manage',
};

export { ENDPOINTS };
